<template>
	<div class="page-content users-table-view" style="height: 100vh;">
		<div class="container-fluid bracket-custom-style">
			<Card class="header-card">
				<Row class="competition-row-header-style">
					<Col :md="user && user.role[0] === 'manager' ? 24 : 16" :xs="user && user.role[0] === 'manager' ? 24 : 12"
						:lg="24" :xl="16" class="competition-card-header-style">
					<span class="page-title d-none d-lg-inline">{{ $t('menu.competitions') }}</span>
					<Select v-model="tableLenght" style="width: 70px;" :placeholder="$t('global.kiezen')">
						<Option :value="10">10</Option>
						<Option :value="25">25</Option>
						<Option :value="50">50</Option>
						<Option :value="100">100</Option>
					</Select>

					<div class="d-flex align-items-center mt-3 mt-md-0">
						<div class="d-flex position-relative ml-0 ml-md-2 ml-lg-3 mr-2">
							<small class="date-label-style">Start</small>
							<DatePicker v-model="startCompYear" @on-change="onChangeStartCompYear"
								@on-clear="() => startCompYear = getCurrentDate()" type="year" id="startCompYear" split-panels
								placeholder="Select date" style="width: 100px;"></DatePicker>
						</div>

						<span class="text-center">-</span>

						<div class="d-flex position-relative ml-2 mr-2 mr-lg-3">
							<small class="date-label-style">End</small>
							<DatePicker v-model="endCompYear" @on-change="onChangeEndCompYear"
								@on-clear="() => endCompYear = getCurrentEndDate()" type="year" id="endCompYear" split-panels
								placeholder="Select date" style="width: 100px;"></DatePicker>
						</div>
					</div>

					<Button class="md-checkmark-style mt-3 mt-md-0" @click="switchValability(true)"
						:icon="showFinished ? 'md-checkmark-circle' : 'md-checkmark-circle-outline'">
						{{ $t('user.table.show_finished') }}
						<b v-if="showFinished">: {{ arrayList.data.length }}</b>
					</Button>
					</Col>

					<Col :md="8" :xs="12" :lg="24" :xl="8" class="d-flex mt-0 mt-lg-2 mt-xl-0 justify-content-end">
					<Button v-if="enableFor(['admin', 'super', 'competition_director'])" type="warning" to="/create-competition"
						target="_blank">
						<b>{{ $t('menu.create_competition') }}</b>
					</Button>
					</Col>
				</Row>
			</Card>
			<!-- <Card class="header-card">
				<Row>
					<Col :md="16" :xs="24" class="d-flex">
						<span class="page-title d-none d-lg-inline">{{ $t('menu.competitions') }}</span>
						<div  class="d-flex justify-content-end">
							<Button v-if="enableFor(['admin', 'super', 'competition_director'])" class="mr-2" type="warning" to="/create-competition"
									target="_blank">
								<b>{{ $t('menu.create_competition') }}</b>
							</Button>
						</div>
					</Col>

					<Col :md="8" :xs="24" class="pt-4" >
						<Select v-model="tableLenght" style="width: 70px;" :placeholder="$t('global.kiezen')">
							<Option :value="10">10</Option>
							<Option :value="25">25</Option>
							<Option :value="50">50</Option>
							<Option :value="100">100</Option>
						</Select>

						<Button class="md-checkmark-style" @click="switchValability(true)"
								:icon="showFinished ? 'md-checkmark-circle' : 'md-checkmark-circle-outline'">
							{{ $t('user.table.show_finished') }}
							<b v-if="showFinished">: {{ arrayList.data.length }}</b>
						</Button>

						<Divider />

						<div class="d-flex start">
							<div class="d-flex position-relative ml-3 mr-2">
								<small class="date-label-style">Start</small>
								<DatePicker v-model="startCompYear" @on-change="onChangeStartCompYear"
											@on-clear="() => startCompYear = getCurrentDate()" type="year" id="startCompYear" split-panels
											placeholder="Select date" style="width: 100px;"></DatePicker>
							</div>

							<span class="text-center">-</span>

							<div class="d-flex position-relative ml-2 mr-3">
								<small class="date-label-style">End</small>
								<DatePicker v-model="endCompYear" @on-change="onChangeEndCompYear"
											@on-clear="() => endCompYear = getCurrentEndDate()" type="year" id="endCompYear" split-panels
										placeholder="Select date" style="width: 100px;"></DatePicker>
							</div>

						</div>

					</Col>
				</Row>
			</Card> -->
			<Spin v-if="loading" fix>
				<Icon class="demo-spin-icon-load" size="40" type="ios-loading"></Icon>
				<div>{{ $t('global.loading') }}</div>
			</Spin>
			<Row v-else class="h-100" style="margin-top: 0; overflow: hidden; border-radius: 4px;">
				<Col span="24" class="h-100">
				<div class="card mb-0 h-100">
					<div class="card-body-table h-100" style="overscroll-behavior: none;">
						<table id="users-table" class="table table-bordered dt-responsive table-striped nowrap">
							<thead class="positionThead">
								<tr>
									<th v-if="enableFor(['manager', 'competition_director'])"></th>
									<TableaHeadCol column="name" :title="$t('competition.name')" :sortColumn="sortColumn"
										:sortByValue="sortByValue" @sortBy="ColHead" />
									<TableaHeadCol column="date[0]" :title="$t('club.table.date')" :sortColumn="sortColumn"
										:sortByValue="sortByValue" @sortBy="ColHead" />
									<TableaHeadCol column="stages.length" :title="$t('competition.stages')" :sortColumn="sortColumn"
										:sortByValue="sortByValue" @sortBy="ColHead" />
									<TableaHeadCol column="ttype.name" :title="$t('competition.type')" :sortColumn="sortColumn"
										:sortByValue="sortByValue" @sortBy="ColHead" />
									<TableaHeadCol column="categorySearch" :title="$t('global.category')" :sortColumn="sortColumn"
										:sortByValue="sortByValue" @sortBy="ColHead" />
									<TableaHeadCol column="terenSearch" :title="$t('competition.field')" :sortColumn="sortColumn"
										:sortByValue="sortByValue" @sortBy="ColHead" />
									<TableaHeadCol column="town" :title="$t('competition.regulations')" />
									<TableaHeadCol column="notes.text" :title="$t('competition.notes')" :sortColumn="sortColumn"
										:sortByValue="sortByValue" @sortBy="ColHead" />
									<TableaHeadCol column="nationality" title="" />
								</tr>
								<tr>
									<th v-if="enableFor(['manager', 'competition_director'])"></th>
									<th>
										<Input v-model="search.name" :placeholder="$t('global.search')" clearable />
									</th>
									<th>
										<!-- <Input v-model="search.date" :placeholder="$t('global.search')" clearable /> -->
									</th>
									<th>
										<Input v-model="search.stage" :placeholder="$t('global.search')" clearable />
									</th>
									<th>
										<Input v-model="search.ttypeSearch" :placeholder="$t('global.search')" clearable />
									</th>
									<th>
										<Input v-model="search.categorySearch" :placeholder="$t('global.search')" clearable />
									</th>
									<th>
										<Input v-model="search.terenSearch" :placeholder="$t('global.search')" clearable />
									</th>
									<th></th>
									<th></th>
									<th></th>
								</tr>
							</thead>
							<tbody>
								<template v-for="competition in arrayList.data">
									<tr :rowspan="competition.displayStages.length">
										<td v-if="enableFor(['manager', 'competition_director'])"
											style="vertical-align: middle; position: relative; text-align: center;">
											<Button :to="`/competition/${competition._id}/teams-table`" target="_blank" type="dashed"
												class="user-info-btn" icon="md-eye">
											</Button>
										</td>
										<td>
											<div class="d-flex justify-content-between">
												<div class="d-flex flex-column">
													<h6>{{ competition.name }}</h6>
													<small>{{ $t('competition.reg_close') }} - {{
														$moment(competition.reg_date[1]).format('DD.MM.YYYY') }}</small>
												</div>
												<div class="d-flex flex-column ml-2">
													<Button v-if="enableFor(['admin', 'super', 'competition_director'])" target="_blank"
														type="dashed" :to="`/edit-competition/${competition._id}`">
														<i class="bx bx-edit font-size-15 align-middle"></i>
													</Button>
													<Button v-if="competition.isCompleted" type="dashed" @click="printComp(competition._id)"
														class="mt-2">
														<i class="bx bx-printer font-size-15 align-middle"></i>
													</Button>
												</div>
											</div>
										</td>
										<td>{{ $moment(competition.date[0]).format('DD.MM.YYYY') }} <br /> {{
											$moment(competition.date[1]).format('DD.MM.YYYY') }}</td>
										<td class="m-0 p-0">
											<!-- <div > -->
											<template v-for="(stage, i) in competition.displayStages.filter((stage) => !stage.isPlayoff)">
												<div
													:class="i === competition.displayStages.filter((stage) => !stage.isPlayoff).length - 1 ? 'fake-cell' : 'fake-cell-w-border'">
													{{ $moment(stage.date_start).format('DD.MM.YYYY') }}
													{{ stage.date_end ? ' - ' + $moment(stage.date_end).format('DD.MM.YYYY') : '' }}
												</div>
											</template>
											<!-- </div> -->
										</td>
										<td>
											{{ competition.ttype.short_name }}
										</td>
										<td>
											{{
												competition.formats
													.filter((item, index, arr) => {
														return arr.findIndex(obj => obj.category._id === item.category._id) === index;
													})
													.map((cat) => `${cat.category.name}`)
													.toString()
													.replaceAll(",", '\n')
											}}
										</td>
										<td class="m-0 p-0">
											<template v-for="(stage, i) in competition.displayStages.filter((stage) => !stage.isPlayoff)">
												<div
													:class="i === competition.displayStages.filter((stage) => !stage.isPlayoff).length - 1 ? 'fake-cell text-center' : 'fake-cell-w-border text-center'">
													{{ stage.stadium }}
												</div>
											</template>
										</td>
										<td>
											<div v-if="competition.regulations.length > 0">
												<template v-for="(regulation, idx) in competition.regulations">
													<a :href="api_domain + regulation" target="_blank">
														<Icon :key="'regulation_' + idx" color="#2d8cf0" custom="bx bxs-file-pdf" size="25"
															type="primary"></Icon>
													</a>
												</template>
											</div>
											<!-- <Icon v-if="item.newmembership" type="md-alert" color="red" class="alert-expire-date" /> -->
										</td>
										<td>{{ competition.notes.text }}</td>

										<td>
											<Button :disabled="competition.isCompleted" v-if="checkTeamsForCompetition(competition) === 2"
												:to="`/competition/${competition._id}/team/${user.clubId._id}`" target="_blank" type="success"
												long>{{
													$t('competition.registered') }}</Button>
											<Button :disabled="competition.isCompleted" v-if="checkTeamsForCompetition(competition) === 0"
												:to="`/competition/${competition._id}/team`" target="_blank" type="primary" long>{{
													$t('competition.register')
												}}</Button>
											<Button :disabled="competition.isCompleted" v-if="checkTeamsForCompetition(competition) === 1"
												:to="`/competition/${competition._id}/team/${user.clubId._id}`" target="_blank" type="warning"
												long>{{
													$t('competition.augment') }}</Button>
											<Button v-if="checkTeamsForCompetition(competition) === 3"
												:to="`/competition/${competition._id}/teams-table`" target="_blank" type="success" long>{{
													$t('competition.complete') }}</Button>
											<Button v-if="checkTeamsForCompetition(competition) === 4"
												:to="`/competition/${competition._id}/teams-table`" target="_blank" type="warning" long>{{
													$t('competition.incomplete') }}</Button>
										</td>


									</tr>
								</template>
							</tbody>
						</table>
					</div>
				</div>
				</Col>
			</Row>
			<Card>
				<div class="competition-footer-card">
					<div>
						<span v-if="competitions.length">
							{{ $t('global.entries') }}
							{{ getPageLabel(arrayList.total, parseInt(tableLenght), arrayList.page - 1) }}
							{{ $t('global.of') }} {{ competitions.length }} {{ $t('global.entry') }} ({{ $t('global.filtered', {
								len:
									array.length
							}) }})
						</span>
						<span v-else>
							{{ $t('global.entries') }} {{ getPageLabel(arrayList.total, parseInt(tableLenght), arrayList.page - 1) }}
							{{
								$t('global.of') }} {{ array.length }}
							{{ $t('global.entry') }}
						</span>
					</div>
					<Page @on-change="changePage" v-if="arrayList.total > 0" :current="arrayList.page"
						:page-size="parseInt(tableLenght)" :total="arrayList.total" />
				</div>
			</Card>
		</div>
	</div>
</template>
<script>
import mixin from '../mixinTable';
import TableaHeadCol from '../helper/table/TableaHeadCol';
import html2pdf from 'html2pdf.js';
import {
	competitionHTML,
	closingHtmlString,
} from "./brackets/htmlHelpers";
export default {
	name: 'CompetitionsList',
	components: {
		TableaHeadCol,
	},
	mixins: [mixin],
	data() {
		return {
			isPrint: false,
			showFinished: false,
			checked: [],
			clubs: [],
			filterClub: [],
			filterSex: [],
			loading: false,
			user: null,
			time: '',
			competitions: [],
			allCompetitions: [],
			teams: [],
			filterByDateCompetition: [],
			startCompYear: this.getCurrentDate(),
			endCompYear: this.getCurrentEndDate(),
			tableTable: '',
		};
	},
	watch: {
		async tableLenght(n, o) {
			await this.getCompetitions()
			localStorage.setItem('dt.length', n)
			// await this.getTempList()
		}
	},
	methods: {
		filterByCategory(arr) {
			for (let i = 0; i < arr.length; i++) {
				const element = arr[i];
				const grouped = element.stages.reduce((acc, obj) => {
					const category = obj.category;
					if (!acc[category]) {
						acc[category] = [];
					}
					acc[category].push(obj);
					return acc;
				}, {});

				const maxCategory = Object.keys(grouped).reduce((a, b) =>
					grouped[a].length > grouped[b].length ? a : b
				);

				arr[i].displayStages = grouped[maxCategory];
			}
		},
		isMobile() {
			if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
				return true
			} else {
				return false
			}
		},
		async printComp(id) {
			try {
				// const res = await this.$http.get("/competition/print/" + id)

				// window.open('http://localhost:4001/competition/print/' + id, '_blank');
				window.open('https://rugby-api.mindscape.xyz/competition/print/' + id, '_blank');

				// printWindow.document.close();

				// const opt = {
				// 	margin: 12,
				// 	filename: 'print.pdf',
				// 	html2canvas: {
				// 		scale: 2,
				// 		scrollX: 0,
				// 		scrollY: 0,
				// 		windowWidth: document.body.scrollWidth,
				// 		windowHeight: document.body.scrollHeight,
				// 	},
				// 	pagebreak: { mode: ['avoid-all', 'css', 'legacy'], before: '.table-wrapper', avoid: 'table' },
				// 	jsPDF: {
				// 		orientation: 'p',
				// 		unit: 'mm',
				// 		format: 'a4',
				// 	},
				// };




				// let worker = html2pdf()
				// 	.from(res.data)
				// 	.set(opt)
				// 	.toContainer()
				// 	.toCanvas()
				// 	.toImg();
				// await worker.toPdf().save();
			} catch (error) {
				console.log(error);
			}
		},
		getCurrentDate() {
			const date = new Date()
			let returnDate = new Date(date.setFullYear(date.getFullYear()))
			return returnDate.toString()
		},
		getCurrentEndDate() {
			const date = new Date()
			let returnDate = new Date(date.setFullYear(date.getFullYear() + 1))
			return returnDate.toString()
		},
		onChangeStartCompYear(value) {
			console.log("onChangeStartCompYear", new Date(value))
			this.filterByDateCompetition[0] = new Date(value)
		},
		async onChangeEndCompYear(value) {
			console.log("onChangeStartCompYear", value)
			this.filterByDateCompetition[1] = new Date(value)

			console.log("filterByDateCompetition", this.filterByDateCompetition)
			await this.getCompetitions()
		},
		ColHead(val) {
			this.sortColumn = val;
			this.sortBy();
		},
		enableFor(arr) {
			if (!this.$user.data.role) return false;
			return arr.includes(this.$user.data.role[0])
		},
		switchValability(src) {
			if (src)
				this.showFinished = !this.showFinished;
			let completed = [...this.allCompetitions.filter(({ isCompleted }) => isCompleted)]
			let incompleted = [...this.allCompetitions.filter(({ isCompleted }) => !isCompleted)]
			if (this.showFinished) {
				this.competitions = [...completed]
				this.arrayList = this.paginator(this.competitions.reverse(), 1, this.tableLenght)
			} else {
				this.competitions = [...incompleted]
				this.arrayList = this.paginator(this.competitions.reverse(), 1, this.tableLenght)
			}
		},
		getCurrentUser() {
			const user = localStorage.getItem('user');
			this.user = JSON.parse(user);
		},
		async getCompetitions() {
			try {
				const res = await this.$http.post('/competition/list', { 'date.0': { $gte: this.filterByDateCompetition[0], $lte: this.filterByDateCompetition[1] } });
				let spareArray = res.data.map((comp) => {
					return {
						ttypeSearch: comp.ttype.short_name, ...comp,
						terenSearch: comp.stages.map((stage) => { return stage.stadium }).toString().replaceAll(",", " "), ...comp,
						categorySearch: comp.formats.map((format) => { return format.category.name }).toString().replaceAll(",", " "), ...comp
					}
				})
				this.filterByCategory(spareArray)
				this.competitions = spareArray;
				this.allCompetitions = spareArray;
				console.log(this.competitions);
				this.switchValability(false)
				this.array = [...this.competitions.reverse()]
				// this.arrayList = this.paginator(this.competitions, 1, this.tableLenght)
			} catch (error) {
				console.log(error);
			}
		},
		checkTeamsForCompetition(comp) {
			if (this.user.role.includes('manager')) {
				if (
					this.teams.some(
						(team) => team.players.length < comp.ttype.max_count && team.clubId._id === this.user.clubId._id && team.competition_id === comp._id
					)
				) {
					return 1;
				} else if (
					this.teams.some(
						(team) => team.players.length >= comp.ttype.max_count && team.clubId._id === this.user.clubId._id && team.competition_id === comp._id
					)
				) {
					return 2;
				}
				return 0;
			} else if (this.user.role.includes('admin') || this.user.role.includes('super')) {
				let { __v, id, additional_info, additional_spends, _id, ...other } = comp;
				let fields = Object.keys(other);
				// console.log(fields)
				let flag = 3;
				for (let i = 0; i < fields.length; i++) {
					const element = fields[i];
					if (typeof comp[element] === 'string' || typeof comp[element] === 'number' || (typeof comp[element] === 'object' && !comp[element].hasOwnProperty('length'))) {
						if (!comp[element]) {
							flag = 4;
						}
					} else if (typeof comp[element] === 'object' && comp[element].hasOwnProperty('length')) {
						if (!comp[element].length) {
							flag = 4;
						}
					}
				}
				return flag;
			}
		},
		async getCompetitionTeams() {
			try {
				const res = await this.$http.post('/team/list', {});
				this.teams = res.data;
			} catch (error) {
				console.log(error);
			}
		},
	},
	async mounted() {
		this.loading = true;
		const today = new Date();
		const thisYear = new Date();
		const twoYearsAgo = new Date();
		twoYearsAgo.setFullYear(today.getFullYear() - 2);
		thisYear.setFullYear(today.getFullYear() + 1);

		this.filterByDateCompetition = [twoYearsAgo, thisYear];
		this.tableLenght = +this.tableLenght;
		await this.getCurrentUser();
		await this.getCompetitions();
		setTimeout(() => { this.loading = false }, 1000)

		await this.getCompetitionTeams();
	},
};
</script>
<style scoped>
.competition-card-header-style,
.competition-row-header-style {
	display: flex;
	align-items: center;
}

.competition-row-header-style {
	flex-wrap: wrap;
}

.bracket-custom-style .ivu-spin {
	background: #454751 !important;
	color: #ffffff;
	z-index: 999;
}

.users-table-view .header-card {
	background: var(--bg-darkness);
	color: var(--text-color);
}

.users-table-view .page-title {
	font-size: 24px;
	font-weight: 600;
}

.users-table-view .table-striped tbody tr:nth-of-type(odd) {
	background-color: #e8e8e8;
}

.users-table-view :global(.ivu-select-selection .ivu-select-placeholder) {
	color: #495057;
}

.users-table-view .table tbody tr:hover,
.users-table-view .table-striped tbody tr:nth-of-type(odd):hover {
	background: #d3d3d3;
}

.date-label-style {
	position: absolute;
	top: -8px;
	left: 0;
	z-index: 99;
	padding: 3px 5px;
	background: var(--burger-menu-btn);
	border-radius: 4px;
	color: #ffffff;
	font-size: 10px;
	line-height: 1;
	font-weight: 600;
}

#users-table {
	border-collapse: inherit;
	border-spacing: 0;
	width: inherit;
	contain: unset;
	table-layout: fixed;
	margin: 0 auto;
}

.users-table-view .card-body-table {
	overflow-x: scroll;
	/* height: calc(100vh - 275px); */
	height: calc(100% - 220px);
	/* height: calc(100vh - 50px); */
	padding: 0;
}

.main-content .page-content .bracket-custom-style {
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	gap: 15px;
}

.competition-footer-card {
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.card-body-table .expire {
	background: #ff000047;
}


.card-body-table .todayBirthday {
	background: #8fbc8f75;
}

.card-body-table .tomorrowBirthday {
	background: #ffff0042;
}

#users-table :global(.ivu-tooltip-rel) {
	cursor: pointer;
}

/*.sort-by {*/
/*  display: inline-block;*/
/*  float: right;*/
/*  cursor: pointer;*/
/*}*/

.user-info-btn {
	padding: 5px 10px;
}

.user-active {
	color: green;
}

.user-blocked {
	color: red;
}

.medical-expired {
	background: #ff000047;
}

#users-table td.user-style :global(.ivu-tooltip-rel) {
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;
	max-width: 100%;
	vertical-align: middle;
}

#users-table td.user-style :global(.ivu-tooltip) {
	width: 205px;
}

#users-table td.user-iban-style :global(.ivu-tooltip) {
	width: 180px;
}

#users-table tr td {
	font-size: 14px !important;
	line-height: 15px;
}

#users-table tr td,
#users-table tr th {
	vertical-align: middle;
	padding: 7px 5px;
	position: relative;
}

#users-table td.user-phone-list :global(.ivu-tooltip-rel) {
	text-overflow: ellipsis;
	overflow: hidden;
	vertical-align: middle;
	max-height: 32px;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
}

#users-table td.user-phone-list :global(.ivu-tooltip) {
	width: 129px;
}

.fake-cell-w-border {
	padding: 5 7;
	border-bottom: 2px solid #eff2f7;
}

.fake-cell {
	padding: 5 7;
}

.badge-soft-primary {
	background-color: #dbe1f7 !important;
}

.good-rating {
	color: #18be6b;
}

.average-rating {
	color: #ff9a01;
}

.black-list-rating {
	color: #ee4014;
}

.md-checkmark-style :global(.ivu-icon-md-checkmark-circle:before) {
	color: #18be6b;
}

.md-checkmark-style :global(.ivu-icon-md-checkmark-circle:before),
.md-checkmark-style :global(.ivu-icon-md-checkmark-circle-outline:before) {
	line-height: 1;
	font-size: 16px;
}

@media only screen and (max-width: 767.98px) {
	.competition-card-header-style {
		flex-direction: column;
		align-items: flex-start;
	}

	.competition-row-header-style {
		align-items: flex-start;
	}

	.competition-footer-card {
		text-align: center;
		flex-direction: column;
		gap: 15px;
	}

	.main-content .page-content .bracket-custom-style {
		gap: 15px;
		padding-bottom: 50px;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/competitions/CompetitionsList.vue